import React from 'react';

import cookie from 'react-cookies';
import PropTypes from 'prop-types';
import connect from 'react-redux/lib/connect/connect';

import * as ReportDucks from 'ducks/reports/report';
import * as RouteDucks from 'ducks/routes';

import SectionLoaderAtom from 'atoms/SectionLoader';
import PaginationComponent from 'components/common/Pagination';
import ManualCorrectionTableComponent from 'components/reports/manualCorrectionSummary/Table';

/**
 * ReportDetailPage -> ManualCorrectionSummaryListSection
 *
 * Components:
 *    - {@link ManualCorrectionTableComponent}
 *    - {@link PaginationComponent}
 *
 * State:
 *    - reportData
 *
 * Actions:
 *    None
 */
const ManualCorrectionSummaryListSection = (props) => {
  const { data, isLoading, location, reportDetail } = props;
  const {query} = location;
  const cookieData = cookie.load("manual_correction_page_size");
  let pageSize;

  if (query && query.page_size)  pageSize = +query.page_size;
  else if(cookieData) pageSize = +cookieData;
  else pageSize = 10;

  if (isLoading) return <SectionLoaderAtom active />;
  return (
    <section>
      <ManualCorrectionTableComponent
        data={data}
        location={location}
        child={reportDetail.parent_report}
        pageSize={pageSize}
      />
      <PaginationComponent
        count={data.length}
        location={location}
        cookieKey="manual_correction_page_size"
      />
    </section>
  );
};

const mapStateToProps = state => ({
  data: ReportDucks.reportData(state),
  reportDetail: ReportDucks.reportDetail(state), 
  location: RouteDucks.location(state),
});

const mapActionsToProps = dispatch => ({});

ManualCorrectionSummaryListSection.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
};

ManualCorrectionSummaryListSection.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(ManualCorrectionSummaryListSection);
